import Rebase from 're-base';
import firebase from 'firebase';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDMMxhPmHBRr1_wl-w2oMu0Uei_NrGe1dk",
    authDomain: "cloud-data-store-01.firebaseapp.com",
    databaseURL: "https://cloud-data-store-01.firebaseio.com",
    projectId: "cloud-data-store-01",
    storageBucket: "cloud-data-store-01.appspot.com",
    messagingSenderId: "528523317907",
    appId: "1:528523317907:web:b170f4ba926f00dc"
});

const base = Rebase.createClass(firebaseApp.database());

export { firebaseApp };
export default base;